import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Heading,
} from "@chakra-ui/react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getAuth, confirmPasswordReset } from "firebase/auth";
import { showToast } from "../utils/toastUtils";

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const oobCode = searchParams.get("oobCode"); // Get the oobCode from the query params

  const handleResetPassword = async () => {
    if (!password || !confirmPassword) {
      showToast({
        title: "Error",
        description: "Both password fields are required.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (password !== confirmPassword) {
      showToast({
        title: "Error",
        description: "Passwords do not match.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!oobCode) {
      showToast({
        title: "Error",
        description: "Invalid or missing reset code.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);
      const auth = getAuth();
      await confirmPasswordReset(auth, oobCode, password); // Update the password in Firebase
      showToast({
        title: "Success",
        description: "Your password has been reset successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/login"); // Navigate to the login page after successful reset
    } catch (error: any) {
      console.error("Error resetting password:", error);
      showToast({
        title: "Error",
        description: error.message || "Failed to reset password.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="400px" mx="auto" mt="20" p={8} borderWidth="1px" borderRadius="md">
      <Heading mb={6}>Reset Password</Heading>
      <VStack spacing={4} align="stretch">
        <FormControl isRequired>
          <FormLabel>New Password</FormLabel>
          <Input
            type="password"
            placeholder="Enter new password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Confirm Password</FormLabel>
          <Input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </FormControl>

        <Button
          colorScheme="blue"
          onClick={handleResetPassword}
          isLoading={loading}
          width="full"
        >
          Reset Password
        </Button>
      </VStack>
    </Box>
  );
};

export default ResetPassword;
